import { owners } from './../helpers/modals';
import { SET_MODAL_INFO } from './../actions/modal';
import { LOCATION_CHANGE } from 'react-router-redux/reducer';

const initialState = {
  isVisible: false,
  owner: '',
  infoByOwner: {
    [owners.artifactHitCount]: {
      diffOnly: true,
      metric: undefined,
      isCcf: false
    },
    [owners.buildsBaseline]: { isBaseline: false },
    [owners.caseAmendingBaseline]: { imageName: '' },
    [owners.comment]: { item: {}, dispatcherId: 0, dispatcherType: '', position: '' },
    [owners.commentHistory]: { item: {}, dispatcherId: 0, ticketsOnly: false },
    [owners.changeCommenterName]: { scenarioId: 0, status: '', position: '' },
    [owners.jiraConfirm]: {
      scanKeys: [],
      issue: '',
      typesChecked: {
        ncfHits: false,
        ccfHits: false,
        ncfDuration: false,
        ccfDuration: false,
        ncfSource: false,
        ncfSourceAttribute: false
      }
    },
    [owners.scenarioStatus]: {
      dispatcherId: 0,
      inProgressOnly: true
    },
    [owners.scenarioHistory]: {
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      scenarioName: '',
      runsToShow: 0,
      buildType: 'Production',
      details: true
    },
    [owners.testArtifacts]: {
      runner: 0,
      detailsVisible: {}
    },
    [owners.installerTestsScenarios]: { runners: [] },
    [owners.acknowledgeBaselineUpdate]: {
      scenario: undefined,
      title: '',
      retrigger: true
    }
  }
};

const modal = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      if (!action.payload || !action.payload.search)
        return state;
      const search = action.payload.search;
      if (typeof search === 'string' && search.includes('&rn'))
      {
        const detailsVisibleIndex = search.indexOf('&dv=');
        const info = {
          runner: +(search.substring(
            search.indexOf('&rn=') + 4,
            detailsVisibleIndex !== - 1 ? detailsVisibleIndex :
              search.length
          )),
          detailsVisible: detailsVisibleIndex !== -1 ?
            search.substring(detailsVisibleIndex + 4).split('+')
              .reduce((result, curr) => {
                result[curr] = true;
                return result;
              }, {}) : {}
        };
        const ownerInfo = { [owners.testArtifacts]: info };

        return {
          ...state,
          isVisible: true,
          owner: owners.testArtifacts,
          infoByOwner: {
            ...state.infoByOwner,
            ...ownerInfo
          }
        };
      }
      else
        return state;
    case SET_MODAL_INFO:
      const info = {
        ...state.infoByOwner[action.owner],
        ...action.info
      };
      const ownerInfo = { [action.owner]: info };

      return {
        ...state,
        isVisible: action.visible,
        owner: action.owner,
        infoByOwner: {
          ...state.infoByOwner,
          ...ownerInfo
        }
      };
    default:
      return state;
  }
};

export default modal;

const modalState = state => state.modal;
export const modalInfoByOwner = state => modalState(state).infoByOwner;
export const getModalInfoByOwner = (state, owner) =>
  modalInfoByOwner(state)[owner] || {};

export const getModalVisibility = (state, owner) =>
  state.modal.isVisible && state.modal.owner === owner;


// WEBPACK FOOTER //
// src/reducers/modal.js